import React from 'react';

function Landing() {
  return (
      <div className='container text-center text-white'>
          <h1>
           Welcome To CryptoDash
          </h1>
          <p>A one stop EdTech platform for Blockchain, Crypto, NFT, and Defi Enthusiasts</p>
      </div>
  )
}

export default Landing;
